import { Injectable } from '@angular/core';
import { of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { EmailService } from '../../services/email.service';
import { enviarEmailContato, enviarEmailContatoFailure, enviarEmailContatoSuccess } from '../actions/enviar-email-contato.action';
import { HttpErrorResponse } from '@angular/common/http';
import { EstruturaRetornoOutputDto } from 'src/app/domain/DTOs/output/estrutura-retorno.output.dto';

@Injectable()
export class EnviarEmailContatoEffects {

  public enviarEmailContato$: unknown;

  constructor(private actions$: Actions,
    private emailService: EmailService) {
    this.createEffects()
  }

  private createEffects() {
    this.enviarEmailContato$ = createEffect(() => this.actions$.pipe(
      ofType(enviarEmailContato),
      switchMap(({ enviarEmailContatoInputDto }) =>
        this.emailService
          .enviarEmailContato(enviarEmailContatoInputDto)
          .pipe(
            map(
              response => {
              if (response.erros != undefined && response.erros.length > 0) {
                return enviarEmailContatoFailure({ response })
              }
              return enviarEmailContatoSuccess({ response })
            }),
            catchError((error: HttpErrorResponse) => {
              const e = new EstruturaRetornoOutputDto(Object.values(error?.error?.errors))
              return of( enviarEmailContatoFailure({response: e}))}
            )
          )
      )
    )
    );
  }
}
